import React from "react";
import {
  Typography,
  Chip,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  CalendarToday as CalendarIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const WeatherAlertCard = ({ alert }) => {
  const { t, i18n } = useTranslation();

  const getSeverityStyle = (severity) => {
    switch (severity) {
      case "No Warning":
        return {
          cardBg: "#e8f5e8",
          borderColor: "#4caf50",
          chipBg: "#4caf50",
          chipColor: "#ffffff",
          iconColor: "#2e7d32",
          label: t("No Warning - Conditions are normal"),
        };
      case "Watch":
        return {
          cardBg: "#fffde7",
          borderColor: "#ffeb3b",
          chipBg: "#ffeb3b",
          chipColor: "#333333",
          iconColor: "#fbc02d",
          label: t("Watch - Potential risk, stay alert"),
        };
      case "Alert":
        return {
          cardBg: "#fff3e0",
          borderColor: "#ff9800",
          chipBg: "#ff9800",
          chipColor: "#ffffff",
          iconColor: "#f57c00",
          label: t("Alert - Immediate attention advised"),
        };
      case "Warning":
        return {
          cardBg: "#ffebee",
          borderColor: "#f44336",
          chipBg: "#f44336",
          chipColor: "#ffffff",
          iconColor: "#c62828",
          label: t("Warning - Severe conditions detected"),
        };
    }
  };

  const style = getSeverityStyle(alert.severity);

  return (
    <Accordion
      sx={{
        borderRadius: 3,
        border: `2px solid ${style.borderColor}`,
        bgcolor: style.cardBg,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: style.iconColor }} />}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1.5,
            bgcolor: "rgba(255,255,255,0.7)",
            borderRadius: 2,
          }}
        >
          <CalendarIcon
            sx={{
              color: style.iconColor,
              mr: 1.5,
              fontSize: 20,
            }}
          />
          <Typography
            variant="body1"
            sx={{
              color: "#333",
              fontWeight: 600,
              fontSize: "0.95rem",
            }}
          >
            {new Date(alert.date).toLocaleDateString(i18n.language || "en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Typography>
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: alert.severity === "No Warning" ? 0 : 2,
          }}
        >
          <Chip
            label={style.label}
            sx={{
              bgcolor: style.chipBg,
              color: style.chipColor,
              fontWeight: 700,
              fontSize: "0.8rem",
              borderRadius: 3,
              px: 1,
              py: 0.5,
              letterSpacing: "0.5px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          />
        </Box>

        {alert.severity !== "No Warning" && (
          <Box
            sx={{
              p: 1.5,
              bgcolor: "rgba(255,255,255,0.9)",
              borderRadius: 2,
              borderLeft: `4px solid ${style.borderColor}`,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#2c2c2c",
                lineHeight: 1.7,
                fontSize: "0.95rem",
                fontWeight: 500,
              }}
            >
              {alert.description}
            </Typography>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default WeatherAlertCard;
